import { useReactiveVar } from '@apollo/client';
import { Dialog, DialogContent } from '@mui/material';
import React, { useCallback } from 'react';
import { seasonalityTemplateModalVar } from './variables';
import FinancialProductSeasonalityTemplateViewComponent from './FinancialProductSeasonalityTemplateViewComponent';

const FinancialProductSeasonalityTemplateModalComponent = () => {
  const seasonalityTemplateModal = useReactiveVar(seasonalityTemplateModalVar);
  const close = useCallback((_, reason) => {
    if (reason === 'backdropClick') return true;
    seasonalityTemplateModalVar({ open: false });
  }, []);
  return (
    <Dialog open={seasonalityTemplateModal.open} maxWidth='lg' scroll={'body'} onClose={close} TransitionProps={{ exit: false }}>
      <DialogContent>{seasonalityTemplateModal.open && <FinancialProductSeasonalityTemplateViewComponent templateId={seasonalityTemplateModal.templateId} />}</DialogContent>
    </Dialog>
  );
};

export default FinancialProductSeasonalityTemplateModalComponent;
